import { Stack, StackProps, Typography } from '@mui/material';
import React from 'react';

import { CoreHexIcon } from './CoreHexIcon';

export interface CoreItem {
  id: number;
  icon: any;
  title?: string;
  description?: string;
}

interface CoreLaunchPadCardProps extends StackProps {
  item: CoreItem;
}

export const CoreLaunchPadCard = ({ item, ...rest }: CoreLaunchPadCardProps) => {
  return (
    <Stack gap={{ xs: 2, sm: 5 }} width={'100%'} height={'100%'} {...rest}>
      <CoreHexIcon icon={item.icon} alt={item?.title} />
      {/* <Stack gap={2}>
        {item.title ? (
          <Typography
            component={'h5'}
            variant={'headLarge1'}
            fontSize={{ xs: '18px', sm: '24px' }}
            textAlign={'center'}
            color={'#FFFFFF'}>
            {item.title}
          </Typography>
        ) : null}
        {item.description ? (
          <Typography
            variant={'bodyLarge'}
            color={'#FFFFFF'}
            className={'mix-blend'}
            textAlign={'center'}
            fontSize={{ xs: '14px', sm: '18px' }}>
            {item.description}
          </Typography>
        ) : null}
      </Stack> */}
    </Stack>
  );
};
